"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = MenuCard;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _List = _interopRequireDefault(require("@material-ui/core/List"));

var _MenuItem = _interopRequireDefault(require("./MenuItem"));

var _MenuBack = _interopRequireDefault(require("./MenuBack"));

var _MenuHeader = _interopRequireDefault(require("./MenuHeader"));

var _MenuFooter = _interopRequireDefault(require("./MenuFooter"));

var _MenuContext = _interopRequireDefault(require("./MenuContext"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function MenuCard(_ref) {
  _ref = Object.assign({}, {}, _ref);
  var item = _ref.item,
      depth = _ref.depth,
      headerProps = _ref.headerProps;

  var _useContext = (0, _react.useContext)(_MenuContext["default"]),
      _goBack = _useContext.goBack,
      classes = _useContext.classes,
      expandFirstItem = _useContext.expandFirstItem,
      drawerWidth = _useContext.drawerWidth;

  return /*#__PURE__*/_react["default"].createElement(_List["default"], {
    style: {
      width: "".concat(drawerWidth, "px")
    },
    classes: {
      root: classes.list,
      padding: classes.padding
    },
    key: depth
  }, !item.root && /*#__PURE__*/_react["default"].createElement(_MenuBack["default"], (0, _extends2["default"])({
    classes: classes,
    goBack: function goBack() {
      return _goBack(depth - 1);
    },
    item: item,
    card: depth
  }, headerProps)), /*#__PURE__*/_react["default"].createElement(_MenuHeader["default"], {
    item: item
  }), item.items && item.items.map(function (child, i) {
    return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
      item: child,
      key: item.key + '-' + i // this ensures that the expanded state is after showing a new card
      ,
      depth: depth,
      defaultExpanded: i === 0 && expandFirstItem
    });
  }), /*#__PURE__*/_react["default"].createElement(_MenuFooter["default"], {
    item: item
  }));
}

MenuCard.propTypes = {
  /**
   * Addition props for the header element
   */
  headerProps: _propTypes["default"].object
};
